<!-- Fragmentación de stock por clientes -->

<div *ngIf="fragmentacionData.length > 0"
     class=" stats-container animated fadeIn">

    <div class="stat-card border-warning">

        <!-- Título -->
        <div class="stat-title">
            Estado de Fragmentación de stock por clientes
        </div>

        <!-- Total clientes -->
        <div class="stat-value mb-4">
            {{ fragmentacionData.length }}
            <span class="clientes-label">clientes</span>
        </div>

        <!-- Clientes -->
        <div class="clientes-fragmentacion">

            <div class="cliente-item"
                 *ngFor="let item of fragmentacionData"
                 (click)="detalleCliente(item)"
                 title="Abrir detalle de fragmentación del cliente">

                <!-- Nombre -->
                <div class="cliente-nombre text-truncate"
                     [title]="item.cliente_nombre">
                    {{ item.cliente_nombre }}
                </div>

                <!-- Estados -->
                <div class="cliente-estados">

                    <span class="estado low"
                          *ngIf="item.severidad.baja > 0">
                        <i class="fa-solid fa-circle-check"></i>
                        <span class="estado-label">Baja</span>
                        <span class="estado-value">{{ item.severidad.baja }}</span>
                    </span>

                    <span class="estado warning"
                          *ngIf="item.severidad.media > 0">
                        <i class="fa-solid fa-triangle-exclamation"></i>
                        <span class="estado-label">Advertencia</span>
                        <span class="estado-value">{{ item.severidad.media }}</span>
                    </span>

                    <span class="estado critical"
                          *ngIf="item.severidad.alta > 0">
                        <i class="fa-solid fa-fire"></i>
                        <span class="estado-label">Crítico</span>
                        <span class="estado-value">{{ item.severidad.alta }}</span>
                    </span>

                </div>

            </div>

        </div>

        <!-- Icono decorativo -->
        <i class="stat-icon fa-solid fa-cubes-stacked"></i>

    </div>

</div>